import styled from 'styled-components';

import { ANIM, COLORS, GRADIENTS } from '@/nova/theme/tokens';
import { Text } from '@/nova/components';

// Shared form controls (FormCol, FieldGroup, GroupLabel, StatusRow, SegChips, SegChip, Helper)
// live in ../formControls.styles and are imported directly by the component.

// --- custom sheet header: gradient title + SSO deep-link icon ---------------
// Mirrors the default Sheet Title (gradient text) so replacing the title via the Sheet's
// `header` slot looks identical, with a trailing bare icon button next to it.
export const SheetHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const SheetHeaderTitle = styled(Text)`
  font-size: 17px;
  font-weight: 900;
  line-height: 1.15;
  background: ${GRADIENTS.backHeaderTitle};
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
`;

export const SheetSsoBtn = styled.button`
  display: inline-grid;
  place-items: center;
  flex: 0 0 auto;
  padding: 6px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: ${COLORS.textFaint};
  line-height: 0;
  cursor: pointer;
  transition:
    background ${ANIM.INTERACT_MS}ms,
    color ${ANIM.INTERACT_MS}ms;

  &:hover {
    background: ${COLORS.hoverWash};
    color: ${COLORS.ctaText};
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.accent};
    outline-offset: 2px;
  }
`;

// --- invite-token result panel ---------------------------------------------
export const InvitePanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  border-radius: 12px;
  background: ${COLORS.surfaceMuted};
  border: 1px solid ${COLORS.panelBorder};
`;

export const InviteTitle = styled(Text)`
  font-size: 14px;
  font-weight: 600;
  color: ${COLORS.heading};
`;

export const InviteBody = styled(Text)`
  font-size: 13px;
  line-height: 1.5;
  color: ${COLORS.textMuted};
`;

export const TokenBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TokenText = styled.code`
  flex: 1;
  min-width: 0;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-family: monospace;
  word-break: break-all;
  background: ${COLORS.surfaceInset};
  border: 1px solid ${COLORS.panelBorder};
  color: ${COLORS.text};
`;
